import { Injectable } from '@angular/core';
import { UserResponseDTO } from '@app/modules/user/interfaces/user-response-dto.interface';

import { BaseGuard } from './baseGuard.guard';

@Injectable()
export class SuperUserGuard extends BaseGuard {
  protected override check(user: UserResponseDTO, isLogged: boolean): boolean {
    if (!isLogged) {
      this.router.navigate(['']);

      return false;
    }

    if (user.defaultRoleId !== 0) {
      this.router.navigate(['/analytics/overview']);

      return false;
    }

    return true;
  }
}
